import React from 'react';
import { api } from '../../App';
import { toast } from 'sonner';
import { Button } from '../ui/button';

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const HoldingsList = ({ portfolio, onChange }) => {
  const act = async (fn, ok) => {
    try {
      const res = await fn();
      toast.success(res.data.message || ok);
      onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Action failed');
    }
  };
  const positions = portfolio?.positions || [];
  const listings = portfolio?.listings || [];

  return (
    <div className="space-y-4" data-testid="live-holdings" data-sb-live>
      <h3 className="text-white font-semibold">My shares</h3>
      {positions.length === 0 && <p className="text-sm text-gray-500" data-testid="live-holdings-empty">You don't own any shares yet.</p>}
      {positions.map((p) => (
        <div key={p.business_id} className="flex items-center justify-between p-3 rounded-lg bg-white/5 border border-white/10" data-testid={`live-position-${p.business_id}`}>
          <div>
            <p className="text-white font-medium">{p.business_name}</p>
            <p className="text-xs text-gray-500">{p.shares.toFixed(4)} shares · {money(p.price)} each · worth {money(p.value)}</p>
          </div>
          <Button size="sm" variant="outline" className="border-white/10" data-testid={`list-shares-btn-${p.business_id}`}
            onClick={() => act(() => api.post(`/sb-live/listings/${p.business_id}`, {}), 'Listed')}>List for sale</Button>
        </div>
      ))}
      {listings.length > 0 && <h3 className="text-white font-semibold pt-2">Waiting for a buyer</h3>}
      {listings.map((l) => (
        <div key={l.listing_id} className="flex items-center justify-between p-3 rounded-lg bg-[#F7931A]/5 border border-[#F7931A]/20" data-testid={`live-listing-${l.listing_id}`}>
          <p className="text-sm text-gray-300">{l.business_name}: {l.remaining_shares.toFixed(4)} of {l.shares.toFixed(4)} shares left at {money(l.price)}</p>
          <Button size="sm" variant="ghost" className="text-red-400" data-testid={`cancel-listing-btn-${l.listing_id}`}
            onClick={() => act(() => api.delete(`/sb-live/listings/${l.listing_id}`), 'Listing cancelled')}>Cancel</Button>
        </div>
      ))}
      {(portfolio?.orders || []).length > 0 && (
        <div className="pt-2">
          <h3 className="text-white font-semibold mb-2">Card purchases</h3>
          {portfolio.orders.map((o) => (
            <p key={o.order_id} className="text-xs text-gray-400" data-testid={`live-order-${o.order_id}`}>
              {new Date(o.created_at).toLocaleString()} · {o.business_name} · {money(o.amount)} · {o.status}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
